import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "text-xs font-semibold text-neutral-600" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { key: 7 }
const _hoisted_13 = { key: 8 }
const _hoisted_14 = { key: 9 }
const _hoisted_15 = { key: 10 }
const _hoisted_16 = { key: 11 }
const _hoisted_17 = ["id"]
const _hoisted_18 = {
  class: "flex items-center space-x-3",
  id: "actions"
}
const _hoisted_19 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_20 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_21 = { key: 12 }
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "text-xs font-semibold text-neutral-600" }
const _hoisted_24 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_25 = { class: "flex flex-col space-y-3" }
const _hoisted_26 = { key: 13 }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "mb-2 text-xs font-semibold text-neutral-600" }
const _hoisted_29 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_30 = { class: "flex flex-col space-y-3" }
const _hoisted_31 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_32 = {
  key: 14,
  class: "flex text-xs italic text-gray-600"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "This field is connected to patient information record. If blank, there is no data encoded.", -1)

import { ref, type PropType, onMounted, watch, computed } from "vue";
import { IonSkeletonText, onIonViewWillEnter } from '@ionic/vue';

//Main Components
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import CKEditor from "@/components/inputs/CKEditor.vue";
import TimePicker from "@/components/inputs/TimePicker.vue";
import ToggleSwitch from "@/components/inputs/ToggleSwitch.vue";

//Components
import FormField from "@/views/interventions/Components/Input/FormField.vue"

//Icons
import { LinkIcon, InformationCircleIcon } from "@heroicons/vue/24/outline";

//Enums
import { FormFieldType } from "@/views/enums/FormFieldType";

//Classes
import DropdownService from "@/classes/Dropdowns/DropdownService";
import { useNetworkStore } from "@/store/network";

//Interfaces
import { 
    FieldInterface,
    FormInterface,
    PatientInterface, 
} from "@/interfaces/pages/InterventionForm/InterventionFormInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
    field: {
        type: Object as PropType<FieldInterface>,
        required: true
    },
    form: {
        type: Object as PropType<FormInterface[]>,
        required: true
    },
    disabled:  {
        type: Boolean,
        required: false
    },
    errors: {
        type: Object,
        required: true
    },
    isEdit: {
        type: Boolean,
        default: false
    },
    isDone: {
        type: Boolean,
        default: false
    },
    patient:  {
        type: Object as PropType<PatientInterface>,
        required: true
    },
},
  setup(__props) {

const networkStore = useNetworkStore();

const props = __props;

const form = ref<any>(props.form)

const field = ref<FieldInterface>(props.field)

const subForms = ref<any>({
    parent: null,
    fields: null
})

const errors = ref<any>(props.errors)
const loaded = ref<boolean>(false)
const reloadChildDropdown = ref<boolean>(true)

const isNetworkAvailable = computed<boolean>(():boolean => networkStore.isNetworkAvailable);

const defaultFormTags: string[] = [
    "patient_name",
    "patient_age",
    "patient_birthday",
    "patient_education",
    "patient_guardian",
    "office",
    "patient_assessment_date",
    "patient_education_name",
    "patient_sex",
]

const yesNoOption = [
	{ id: 1, label: "Yes", value: true },
	{ id: 0, label: "No", value: false },
];

const disabledField = computed<boolean>(():boolean => {
    if(defaultFormTags.includes(field.value.form_tag)){
        return true;
    }

    if(field.value.form_tag == 'done_date_time' && props.isDone){
        return false;
    }

    return field.value.form_tag == 'type' && props.disabled
})

const hasPrerequisiteInfo = ():boolean => {
    if(defaultFormTags.includes(field.value.form_tag)){
        return true;
    }

    return false;
}

const fieldIndex = computed<number>(():number => {
    return Object.values(form.value).map((item:any) => item.source_id).indexOf(field.value.source_id)
})

const init = async ():void => {
    loaded.value = false;
    
    if(fieldIndex.value == -1){
        form.value.push({
            "source_type": field.value.source_type,
            "source_id": field.value.source_id,
            "label": field.value.label,
            "input_type": field.value.input_type,
            "is_required": field.value.is_required,
            "form_tag": field.value.form_tag,
            "value": null,
            "option_child": field.value?.option_child?.source_id ?? null,
        });

        if(FormFieldType.MULTI_SELECT == field.value.input_type){
            form.value[fieldIndex.value].value = [];
        }

        errors.value[fieldIndex.value] = null;
    } else {
        loadFormData();
    }

    if(field.value?.option_class){
        await getFieldOptions()
    }
    
    setFormTagsDefaultValue()

    setTimeout(() => {
        loaded.value = true;
    }, 300);
}

const setFormTagsDefaultValue = ():void => {
    if(defaultFormTags.includes(field.value.form_tag)){
        form.value[fieldIndex.value].value = props.patient[field.value.form_tag]
    }
}

const loadFormData = ():void => {
    const multiFormFlied = [
        FormFieldType.DROPDOWN,
        FormFieldType.RADIO,
        FormFieldType.CHECKBOX_SINGLE,
        FormFieldType.CHECKBOX_OPTION,
        FormFieldType.TOGGLE,
    ];
    
    if(multiFormFlied.includes(form.value[fieldIndex.value].input_type)){
        hasForm()
    }
}

const openLink = (): void => {

    if(form.value[fieldIndex.value].value){
        errors.value[fieldIndex.value] = null;
        window.open(form.value[fieldIndex.value].value, "_blank");
    } else {
        errors.value[fieldIndex.value] = "Please enter url"
    }
}

const checkboxSingleSelect = (value:number|null):void => {
    if(value){
        if(form.value[fieldIndex.value].value == value){
            form.value[fieldIndex.value].value = null
        } else {
            form.value[fieldIndex.value].value = value
        }
    
        hasForm();
    } else {
        console.error('error');
    }
}

const toggleChange = ():void => {

    if(form.value[fieldIndex.value].value == field.value?.options[0]?.id){
        form.value[fieldIndex.value].value = null
    } else {
        form.value[fieldIndex.value].value = field.value?.options[0]?.id
    }

    hasForm()
}

const inFieldValue = (value:number): boolean => {
    if(!Array.isArray(form.value[fieldIndex.value].value)){
        return false;
    }

    return form.value[fieldIndex.value].value.includes(value);
}

const checkboxOptionsSelect = (value:number):void => {

    if(!Array.isArray(form.value[fieldIndex.value].value)){
        form.value[fieldIndex.value].value = [];
    }

    const index = form.value[fieldIndex.value].value.indexOf(value)

    if(index == -1) {
        form.value[fieldIndex.value].value.push(value)
    } else {
        form.value[fieldIndex.value].value.splice(index, 1) 
    }

    hasForm();
}

const radioChange = (value:number):void => {
    form.value[fieldIndex.value].value = value
    hasForm();
}

const getFieldOptions = async ():void => {
    reloadChildDropdown.value = false;
    let parentValue = null;
    
    if(field.value.option_trigger_id){
        field.value.options = null;

        const parentIndex = form.value.map((item:any) => item.source_id).indexOf(field.value.option_trigger_id)

        parentValue = form.value[parentIndex]?.value ?? null;
    }

    await DropdownService
        .interventionFieldOptions(isNetworkAvailable.value, field.value.option_class, field.value.option_trigger_column, parentValue, )
        .then(({data}) => {
            reloadChildDropdown.value = true;
            field.value.options = data
        })
}

//Builds the sub-form 
const hasForm = async ():Promise<void> => {
    loaded.value = false;

    // Check if the selected option does or does not have a sub-form
    if(!field.value?.option_trigger_id != null && field.value?.options){
        const index = field.value.options.map((item:any) => item.value).indexOf(form.value[fieldIndex.value].value)
        
        form.value[fieldIndex.value].value_label = field.value.options[index]?.label;
        
        //Remove previous sub-form from the form
        if(subForms.value.fields != null && form.value[fieldIndex.value].value != subForms.value?.parent){
            await removePreviousSubForm();
        } 
        
        // Resets the sub-form if the selected option does not have a sub-form
        if(field.value.options[index]?.form == undefined) {
            subForms.value = {
                parent: null,
                fields: null
            }
        } 
        
        // Creates the new sub-form if the selected options has a sub-form
        if(index != -1 && field.value.options[index]?.form != undefined){
            subForms.value = {
                parent: form.value[fieldIndex.value].value,
                fields: field.value.options[index]?.form.fields
            }
        }
    }

    setTimeout(() => {
        loaded.value = true;
    }, 500);
}

const removePreviousSubForm = async ():Promise<void> => {

    new Promise((resolve, reject) => {

        const formValue = form.value.map((item:any) => item.source_id)

        subForms.value.fields.forEach((element:FormInterface) => {

                const fieldIndex = formValue.indexOf(element.source_id)

                if(form.value[fieldIndex] != undefined){

                    if(form.value[fieldIndex].option_child) {
                        removeChildOptionFiled(formValue, form.value[fieldIndex].option_child)
                    }
                    
                    form.value.splice(fieldIndex, 1);
                }
            }
        );   
        
        resolve(null);
    })
}


const removeChildOptionFiled = (formValue:any, option_child:number):void => 
{
    const fieldIndex = formValue.indexOf(option_child)

    if(form.value[fieldIndex] != undefined){
        form.value.splice(fieldIndex, 1);
    }
}

const existingDropdown = ():void => {
    reloadChildDropdown.value = false;

    if(field.value.child_option_trigger_id){
        const index = form.value.map((item:any) => item.source_id).indexOf(field.value.child_option_trigger_id)
        form.value[index].value = null
    }
    
    // hasForm()

    setTimeout(() => {
        reloadChildDropdown.value = true;
    }, 300);
    
}
    
watch(
    form.value,
    () => {
        if(field.value.option_trigger_id ){
            getFieldOptions();
        }
    },
);

onMounted(() => {
    init()
})
    
onIonViewWillEnter(() => {
    init()
})


return (_ctx: any,_cache: any) => {
  return (form.value[fieldIndex.value])
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", {
          class: _normalizeClass( field.value.is_half_width ? 'md:col-span-3 col-span-6' : 'col-span-6' )
        }, [
          (_unref(FormFieldType).DROPDOWN == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(MultiSelect, {
                  options: field.value.options,
                  id: field.value.source_id,
                  name: field.value.label,
                  label: field.value.label,
                  placeholder: "Select..",
                  required: field.value.is_required,
                  searchable: "",
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                    _cache[1] || (_cache[1] = ($event: any) => (hasForm()))
                  ],
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["options", "id", "name", "label", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).DROPDOWN_EXISTING == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(MultiSelect, {
                  options: field.value.options,
                  id: field.value.source_id,
                  name: field.value.label,
                  label: field.value.label,
                  placeholder: "Select..",
                  required: field.value.is_required,
                  searchable: "",
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                    _cache[3] || (_cache[3] = ($event: any) => (existingDropdown()))
                  ],
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["options", "id", "name", "label", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).MULTI_SELECT == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(MultiSelect, {
                  mode: "tags",
                  options: field.value.options,
                  id: field.value.source_id,
                  name: field.value.label,
                  label: field.value.label,
                  placeholder: "Select..",
                  required: field.value.is_required,
                  searchable: "",
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["options", "id", "name", "label", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).TOGGLE == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "p-3 space-y-3",
                  id: field.value.source_id
                }, [
                  _createElementVNode("p", _hoisted_6, [
                    _createTextVNode(_toDisplayString(field.value.label) + " ", 1),
                    (field.value.is_required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(ToggleSwitch, {
                    value: form.value[fieldIndex.value].value,
                    noPadding: "",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (toggleChange()))
                  }, null, 8, ["value"])
                ], 8, _hoisted_5),
                (errors.value[fieldIndex.value])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value[fieldIndex.value]), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).DATE_TIME == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(DatePicker, {
                  id: field.value.source_id,
                  name: field.value.label,
                  label: field.value.label,
                  enableTimePicker: true,
                  timePickerInline: true,
                  required: field.value.is_required,
                  isTwentyFour: false,
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["id", "name", "label", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).DATE == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(DatePicker, {
                  id: field.value.source_id,
                  name: field.value.label,
                  label: field.value.label,
                  required: field.value.is_required,
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  enableTimePicker: false,
                  disabled: disabledField.value
                }, null, 8, ["id", "name", "label", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).TIME == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(TimePicker, {
                  id: field.value.source_id,
                  name: field.value.label,
                  label: field.value.label,
                  required: field.value.is_required,
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value,
                  timePicker: "",
                  enableTimePicker: ""
                }, null, 8, ["id", "name", "label", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).TEXT == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(CKEditor, {
                  name: field.value.label,
                  placeholder: field.value.label,
                  label: field.value.label,
                  id: field.value.source_id,
                  required: field.value.is_required,
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["name", "placeholder", "label", "id", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).INPUT == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(TextInput, {
                  name: field.value.label,
                  placeholder: field.value.label,
                  label: field.value.label,
                  id: field.value.source_id,
                  required: field.value.is_required,
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["name", "placeholder", "label", "id", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).NUMBER == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(TextInput, {
                  type: "number",
                  name: field.value.label,
                  placeholder: field.value.label,
                  label: field.value.label,
                  id: field.value.source_id,
                  required: field.value.is_required,
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["name", "placeholder", "label", "id", "required", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).LINK == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(TextInput, {
                  type: "text",
                  name: field.value.label,
                  placeholder: field.value.label,
                  label: field.value.label,
                  id: field.value.source_id,
                  required: field.value.is_required,
                  trailingIcon: _unref(LinkIcon),
                  onIconClick: _cache[12] || (_cache[12] = ($event: any) => (openLink())),
                  customClass: "!pr-10",
                  modelValue: form.value[fieldIndex.value].value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                  error: errors.value[fieldIndex.value],
                  disabled: disabledField.value
                }, null, 8, ["name", "placeholder", "label", "id", "required", "trailingIcon", "modelValue", "error", "disabled"])
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).CHECKBOX_SINGLE == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "flex flex-col space-y-3",
                  id: field.value.source_id
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(CheckboxInput, {
                      label: field.value.label,
                      placeholder: field.value.label,
                      id: field.value.source_id,
                      checked: field.value?.options[0]?.value == form.value[fieldIndex.value].value,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (checkboxSingleSelect(field.value?.options[0]?.value ?? null)))
                    }, null, 8, ["label", "placeholder", "id", "checked"]),
                    (field.value.is_required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  (errors.value[fieldIndex.value])
                    ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(errors.value[fieldIndex.value]), 1))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_17)
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).CHECKBOX_OPTION == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: "space-y-3",
                  id: field.value.source_id
                }, [
                  _createElementVNode("p", _hoisted_23, [
                    _createTextVNode(_toDisplayString(field.value.label) + " ", 1),
                    (field.value.is_required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.value.options, (option, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "items-center p-1 space-x-3",
                        id: "actions",
                        key: index
                      }, [
                        _createVNode(CheckboxInput, {
                          name: option.label,
                          label: option.label,
                          id: option.source_id,
                          checked: inFieldValue(option.value),
                          "onUpdate:modelValue": ($event: any) => (checkboxOptionsSelect(option.value))
                        }, null, 8, ["name", "label", "id", "checked", "onUpdate:modelValue"])
                      ]))
                    }), 128))
                  ])
                ], 8, _hoisted_22)
              ]))
            : _createCommentVNode("", true),
          (_unref(FormFieldType).RADIO == field.value.input_type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("p", _hoisted_28, [
                    _createTextVNode(_toDisplayString(field.value.label) + " ", 1),
                    (field.value.is_required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "*"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(RadioGroup, {
                      id: field.value.source_id,
                      options: field.value?.options ?? yesNoOption,
                      name: field.value.label + field.value.source_id,
                      modelValue: form.value[fieldIndex.value].value,
                      "onUpdate:modelValue": [
                        _cache[15] || (_cache[15] = ($event: any) => ((form.value[fieldIndex.value].value) = $event)),
                        radioChange
                      ],
                      readyOnly: disabledField.value
                    }, null, 8, ["id", "options", "name", "modelValue", "readyOnly"])
                  ]),
                  (errors.value[fieldIndex.value])
                    ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(errors.value[fieldIndex.value]), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (hasPrerequisiteInfo())
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createVNode(_unref(InformationCircleIcon), { class: "w-5 h-5 cursor-pointer text-primary-600" }),
                _hoisted_33
              ]))
            : _createCommentVNode("", true)
        ], 2),
        (subForms.value?.fields != null && loaded.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(subForms.value.fields, (subForm, index) => {
              return (_openBlock(), _createBlock(FormField, {
                key: index,
                field: subForm,
                form: form.value,
                errors: errors.value,
                patient: __props.patient
              }, null, 8, ["field", "form", "errors", "patient"]))
            }), 128))
          : (subForms.value?.fields != null && !loaded.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass( field.value.is_half_width ? 'md:col-span-3 col-span-6' : 'col-span-6' )
              }, [
                _createVNode(_unref(IonSkeletonText), {
                  animated: true,
                  style: {"width":"100%","height":"100%"}
                })
              ], 2))
            : _createCommentVNode("", true),
        (_unref(FormFieldType).DROPDOWN_EXISTING == field.value.input_type && field.value.option_child && reloadChildDropdown.value)
          ? (_openBlock(), _createBlock(FormField, {
              key: 2,
              field: field.value.option_child,
              form: form.value,
              errors: errors.value,
              patient: __props.patient
            }, null, 8, ["field", "form", "errors", "patient"]))
          : (_unref(FormFieldType).DROPDOWN_EXISTING == field.value.input_type && field.value.option_child && !reloadChildDropdown.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: _normalizeClass( field.value.is_half_width ? 'md:col-span-3 col-span-6' : 'col-span-6' )
              }, [
                _createVNode(_unref(IonSkeletonText), {
                  animated: true,
                  style: {"width":"100%","height":"100%"}
                })
              ], 2))
            : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})